export const DOC_TYPES = [
  "Akta Jual Beli",
  "Akta Pendirian PT",
  "Akta Perubahan Anggaran Dasar",
  "Akta Waris",
  "Akta Hibah",
  "Akta Wasiat",
  "Akta Perjanjian",
  "Akta Kuasa",
  "Akta Pengakuan Hutang",
  "Akta Sewa Menyewa",
  "Surat Keterangan Waris",
  "APHT (Hak Tanggungan)",
  "Lainnya",
];

export const SUPPORTING_DOC_CATEGORIES = [
  "Foto KTP",
  "Kartu Keluarga (KK)",
  "Surat Nikah",
  "Sertifikat Tanah",
  "SPPT PBB",
  "Paspor",
  "NPWP",
  "Lainnya",
];
